module.exports = __webpack_public_path__ + "img/live-default-lg.ae9a268a.png";